import React, { ReactElement } from 'react';
import { Trans } from 'react-i18next';
import i18n, { TFunction } from 'i18next';
import { Hyperlink } from '../../components/atoms/Hyperlink';
import { Strong } from '../../components/atoms/Strong/Strong';

export function setPartOfStringBold(key: string, i18nInstance: any, t: TFunction) {
  // eslint-disable-next-line react/jsx-key
  return <Trans i18nKey={key} i18n={i18nInstance} t={t} components={[<Strong>, </Strong>]} />;
}

/**
 * Translate Part of a String with the Trans Component.
 *
 * if the link is an empty string, it will generate a url to the current page
 *
 * translationkey needs to have <0><0>this will be the hyperlink</0></0>,
 * or rather use: <0><0>$t(phrases:goToParentPage)</0></0>
 * */
export function translatePartOfStringWithLink(
  translationKey: string,
  link: string | null = null,
  withRouting = true,
  values: Record<string, string | null | undefined> | undefined = undefined
) {
  return (
    <Trans
      i18nKey={translationKey}
      i18n={i18n}
      values={values}
      components={
        link
          ? [
              // eslint-disable-next-line react/jsx-key
              <Strong>
                <Hyperlink className="global--anchor" routing={withRouting} to={link}>
                  {/* This is a placeholder for the text provided by translation */}
                </Hyperlink>
              </Strong>,
            ]
          : [
              // WE NEED THOSE FRAGMENTS!
              // i18next output expects two HTML elements: <0><0></0></0>
              <>{/* This is a placeholder for the text provided by translation */}</>,
            ]
      }
    />
  );
}

export function replaceStringHtml(s: string, regex: RegExp, fn: (match: string) => [string, ReactElement]) {
  const components: ReactElement[] = [];
  const normalized = s.replace(regex, (match, p1) => {
    const [text, node] = fn(p1);

    components.push(node);

    const index = components.length - 1;

    return `<${index}>${text}</${index}>`;
  });

  return <Trans defaults={normalized} components={components} />;
}
